import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
declare var $: any;

@Injectable({
	providedIn: 'root'
})
export class DialogService {

	// Observable string sources
	private successAlertSource = new Subject<string>();
	private errorAlertSource = new Subject<string>();
	private subjectConfirm = new Subject<any>();

	// Observable string streams
	successAlert$ = this.successAlertSource.asObservable();
	errorAlert$ = this.errorAlertSource.asObservable();

	// Service message commands
	success(message: string) {
		this.successAlertSource.next(message);
	}

	error(message: string) {
		this.errorAlertSource.next(message);
	}

	//#region Confirm Dialog
	confirm(message: string, yesFn: () => void, noFn: () => void = null) {
		this.setConfirmation(message, yesFn, noFn);
	}

	setConfirmation(message: string, yesFn: () => void, noFn: () => void) {
		let that = this;
		this.subjectConfirm.next({
			type: "confirm",
			text: message,
			yesFn: function () {
				that.subjectConfirm.next(); //this will close the modal

				setTimeout(() => {
					yesFn();
				});
			},
			noFn: function () {
				that.subjectConfirm.next();
				if (noFn)
					noFn();
			}
		});
	}

	getConfirmMessage(): Observable<any> {
		return this.subjectConfirm.asObservable();
	}
	//#endregion

	hideDialog(obj: HTMLInputElement) {
		$(obj).modal('hide');
	}
}
